export const MMSE_LICENSING_EVIDENCE = [
  {
    id: 'par-mmse-product',
    authority: 'PAR, Inc.',
    title: 'Mini-Mental State Examination (MMSE)',
    sourceType: 'official-product-page',
    url: 'https://www.parinc.com/products/MMSE',
    results: {
      officialProductPage: true,
      authorizedBrazilianPortuguese: true,
      modifiedVersionRequiresPermission: true
    },
    limitations: [
      'A página oficial informa disponibilidade e regras de uso, mas não substitui avaliação jurídica individual.',
      'Autorização de uso não estabelece, por si só, validade clínica para qualquer população ou contexto.'
    ]
  },
  {
    id: 'par-mmse-permissions',
    authority: 'PAR, Inc.',
    title: 'Product Information / Permissions and Licensing',
    sourceType: 'official-licensing-policy',
    url: 'https://www.parinc.com/customer-support/product-information',
    results: {
      permissionRequiredForModifiedVersion: true,
      permissionRequiredForTranslation: true,
      permissionRequiredForReformatting: true
    },
    limitations: [
      'As exigências concretas dependem do uso pretendido e dos termos vigentes da PAR.'
    ]
  },
  {
    id: 'par-licensing-team',
    authority: 'PAR, Inc.',
    title: 'Licensing Team',
    sourceType: 'official-licensing-policy',
    url: 'https://www.parinc.com/about/connect-with-us/licensing-team',
    results: {
      photocopyingRestricted: true,
      reproductionRequiresPermission: true,
      fullTestUseRequiresPublishedVersion: true
    },
    limitations: [
      'A política descreve materiais da PAR em geral; a aplicação ao MMSE deve ser lida em conjunto com a página oficial do produto.'
    ]
  }
];

export function getMmseLicensingEvidenceById(id) {
  return MMSE_LICENSING_EVIDENCE.find((item) => item.id === id) || null;
}
